import { render, staticRenderFns } from "./moreChatPopover.vue?vue&type=template&id=449f9a48&scoped=true"
import script from "./moreChatPopover.vue?vue&type=script&lang=js"
export * from "./moreChatPopover.vue?vue&type=script&lang=js"
import style0 from "./moreChatPopover.vue?vue&type=style&index=0&id=449f9a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f9a48",
  null
  
)

export default component.exports